import React, { useRef, useState } from "react";
import Slider from "react-slick";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface CarouselProps {
  children: React.ReactNode[];
  slidesToShow: number;
  slidesToScroll: number;
  left?: any;
}

const SlickCarousel: React.FC<CarouselProps> = ({
  children,
  slidesToShow,
  slidesToScroll,
  left,
}) => {
  const sliderRef = useRef<Slider>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    variableWidth: left,
    nextArrow: (
      <ArrowCircleUpIcon
        sx={{
          color:
            currentSlide === children.length - slidesToShow
              ? "#ccc"
              : "#666666",
          transform: "rotate(90deg)",
          mr: -2,
          "&:hover": {
            color:
              currentSlide === children.length - slidesToShow
                ? "#ccc"
                : "#666666",
          },
          cursor:
            currentSlide === children.length - slidesToShow
              ? "not-allowed"
              : "pointer",
        }}
        onClick={() => {
          if (currentSlide < children.length - slidesToShow) {
            sliderRef.current?.slickNext();
          }
        }}
      />
    ),
    prevArrow: (
      <ArrowCircleUpIcon
        sx={{
          color: currentSlide === 0 ? "#ccc" : "#666666",
          transform: "rotate(-90deg)",
          ml: -2,
          "&:hover": { color: currentSlide === 0 ? "#ccc" : "#666666" },
          cursor: currentSlide === 0 ? "not-allowed" : "pointer",
        }}
        onClick={() => {
          if (currentSlide > 0) {
            sliderRef.current?.slickPrev();
          }
        }}
      />
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentSlide(newIndex);
    },
  };
  return (
    <>
      <Slider {...settings} rtl={false} >
        {React.Children.map(children, (child, index) => (
          <div key={index} style={{ padding: "0 10px" }}>
            {child}
          </div>
        ))}
        {/* {React.Children.map(children, (child, index) => (
          <div
            key={index}
            style={{
              // padding: left ? "0 10px 0 0" : "0 10px",
              padding: "0 10px",
              display: "flex",
              justifyContent: left ? "flex-start" : "center",
            }}
          >
            <div
              style={{
                minWidth:"100%",
                display: "inline-block",
              }}
            >
              {child}
            </div>
          </div>
        ))} */}
      </Slider>
    </>
  );
};

export default SlickCarousel;
